if (window.localStorage) {
  document.addEventListener('DOMContentLoaded', function () {
    const STORAGE_KEY = 'preferred-pickup-store';

    document.querySelectorAll('.pickup-location-selector').forEach(function (container) {
      const paramName = container.dataset.paramName;
      const select = container.querySelector('.pickup-location-selector__select');
      const button = container.querySelector('.pickup-location-selector__apply');
      if (!paramName || !select || !button) return;

      function applyFilter(value) {
        const params = new URLSearchParams(window.location.search);
        if (value) {
          params.set(paramName, value);
          window.localStorage.setItem(STORAGE_KEY, value);
        } else {
          params.delete(paramName);
          window.localStorage.removeItem(STORAGE_KEY);
        }
        window.location.search = params.toString();
      }

      const urlParams = new URLSearchParams(window.location.search);
      const currentValue = urlParams.get(paramName);
      const saved = window.localStorage.getItem(STORAGE_KEY);
      const savedIsAvailable = saved && Array.from(select.options).some(function (opt) {
        return opt.value === saved;
      });

      if (currentValue) {
        // URL already has a location filter active (e.g. from a shared link) — respect it, just sync storage
        select.value = currentValue;
        window.localStorage.setItem(STORAGE_KEY, currentValue);
      } else if (savedIsAvailable) {
        // No filter active yet, but we remember a preferred store for this browser — pre-select it,
        // but don't apply until the shopper clicks "Filter" themselves
        select.value = saved;
      } else if (window.pickupGeoWorkerUrl) {
        // First-time visitor, nothing saved yet — try to pre-select their nearest pickup-enabled
        // store by geo-IP (same no-permission-prompt mechanism the product-page widget uses).
        // Pre-select only, same as the saved-preference case — never auto-applies the filter.
        fetch(window.pickupGeoWorkerUrl + '/nearest-location')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data || !data.available) return;
            const match = Array.from(select.options).find(function (opt) {
              return opt.value === data.name;
            });
            if (match) select.value = data.name;
          })
          .catch(function () {});
      }

      // This select intentionally has no `name` and isn't part of the theme's
      // live-filter form data — but a native <select> still fires a bubbling
      // `input` event on selection, and FacetFiltersForm listens for `input`
      // anywhere in the form to auto-submit. Stop it here so picking a store
      // doesn't trigger that until the shopper actually clicks "Filter".
      let touched = false;
      select.addEventListener('input', function (event) {
        event.stopPropagation();
      });
      select.addEventListener('change', function (event) {
        event.stopPropagation();
        touched = true;
      });

      button.addEventListener('click', function () {
        applyFilter(select.value);
      });

      // The mobile filter drawer has its own separate global "Apply" button
      // in its footer — it doesn't actually submit anything itself, it just
      // closes the drawer overlay (checkbox filters already auto-apply on
      // their own). If the shopper picked a store here but tapped that
      // button instead of this control's own "Filter" button, apply their
      // pick too — but only if they actually touched the dropdown, so this
      // never interferes with the button's normal behavior otherwise.
      const mobileApplyButton = container.closest('#Facet-Drawer')?.querySelector('.mobile-filters-apply');
      if (mobileApplyButton) {
        mobileApplyButton.addEventListener('click', function () {
          if (touched) applyFilter(select.value);
        });
      }
    });
  });
}
